import { useState } from "react";
import { MapPin, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

export function GeotagInput({ value, onChange, testId }) {
  const [loading, setLoading] = useState(false);
  const val = value || { lat: "", lng: "" };

  const fetchLocation = () => {
    if (!navigator.geolocation) {
      toast.error("Geolocation not supported by this browser");
      return;
    }
    setLoading(true);
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        onChange({ lat: pos.coords.latitude.toFixed(6), lng: pos.coords.longitude.toFixed(6) });
        setLoading(false);
        toast.success("Location fetched");
      },
      () => {
        setLoading(false);
        toast.error("Unable to fetch location. Enter manually.");
      },
      { enableHighAccuracy: true, timeout: 10000 }
    );
  };

  return (
    <div className="space-y-3">
      <Button type="button" onClick={fetchLocation} disabled={loading} className="bg-emerald-600 hover:bg-emerald-700 text-white" data-testid={testId ? `${testId}-fetch` : undefined}>
        {loading ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : <MapPin className="h-4 w-4 mr-2" />}
        Fetch Location
      </Button>
      <div className="grid grid-cols-2 gap-3">
        <Input
          placeholder="Latitude"
          value={val.lat}
          onChange={(e) => onChange({ ...val, lat: e.target.value })}
          data-testid={testId ? `${testId}-lat` : undefined}
        />
        <Input
          placeholder="Longitude"
          value={val.lng}
          onChange={(e) => onChange({ ...val, lng: e.target.value })}
          data-testid={testId ? `${testId}-lng` : undefined}
        />
      </div>
    </div>
  );
}
